import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AdminSidebar from './components/AdminSidebar';
import OverviewSection from './components/OverviewSection';
import UsersSection from './components/UsersSection';
import AdsSection from './components/AdsSection';
import CampaignsSection from './components/CampaignsSection';
import ContentSection from './components/ContentSection';
import ReportsSection from './components/ReportsSection';

function AdminPage() {
  const [active, setActive] = useState('overview');

  const renderSection = () => {
    switch (active) {
      case 'users':
        return <UsersSection />;
      case 'ads':
        return <AdsSection />;
      case 'campaigns':
        return <CampaignsSection />;
      case 'content':
        return <ContentSection />;
      case 'reports':
        return <ReportsSection />;
      default:
        return <OverviewSection />;
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-24 md:pt-28 pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="flex flex-col lg:flex-row gap-6">
            <AdminSidebar active={active} onSelect={setActive} />
            <div className="flex-1 min-w-0">{renderSection()}</div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default AdminPage;